import construction from './construction.jpg';
import exterior from './exterior.jpg';
import fleet from './fleet.jpg';
import commercial from './commercial.jpg';
const services = { commercial, exterior, fleet, construction };
export default services;
